import { supabase } from "@/integrations/supabase/client";

export const JobViewService = {
  /**
   * Updates the last_viewed_at timestamp for a job
   * @param jobId - The ID of the job to mark as viewed
   */
  markJobAsViewed: async (jobId: string): Promise<void> => {
    try {
      const { error } = await supabase
        .from('jobs')
        .update({ last_viewed_at: new Date().toISOString() })
        .eq('id', jobId);

      if (error) {
        console.error('Error marking job as viewed:', error);
        throw error;
      }
    } catch (error) {
      console.error('Failed to mark job as viewed:', error);
      // Don't throw the error to avoid breaking the user experience
      // The notification badge will still work, just won't be cleared until next page refresh
    }
  },

  /**
   * Updates the last_viewed_at timestamp for multiple jobs
   * @param jobIds - Array of job IDs to mark as viewed
   */
  markJobsAsViewed: async (jobIds: string[]): Promise<void> => {
    try {
      const { error } = await supabase
        .from('jobs')
        .update({ last_viewed_at: new Date().toISOString() })
        .in('id', jobIds);

      if (error) {
        console.error('Error marking jobs as viewed:', error);
        throw error;
      }
    } catch (error) {
      console.error('Failed to mark jobs as viewed:', error);
      // Don't throw the error to avoid breaking the user experience
    }
  }
}; 